import { type ReactNode } from 'react';

/**
 * Âncora de um item do catálogo (`catalogo.ts`) que não é amostra de
 * componente — um bloco de texto, uma escala, uma tabela de regras. É o
 * elemento até onde a busca rola; `ComponentShowcase` faz o mesmo para as
 * amostras.
 */
export function ItemDaDocumentacao({
  id,
  children,
  className,
}: {
  id: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <div data-search-id={id} className={className}>
      {children}
    </div>
  );
}
